import type { OsmTags } from "./types.ts";

export function firstTag(
  tags: OsmTags,
  keys: readonly string[],
): string | undefined {
  for (const key of keys) {
    const value = tags[key];
    if (hasText(value)) return value;
  }
  return undefined;
}

export function tagValue(tags: OsmTags, key: string): string {
  return tags[key]
    ?.split(";")
    .map((part) => part.trim())
    .find((part) => part.length > 0) ?? "";
}

export function tagMatcher(
  key: string,
  value: string,
): (tags: OsmTags) => boolean {
  return (tags) => tagValue(tags, key) === value;
}

export function hasTagValue(value: string | undefined): boolean {
  return value !== undefined && value.trim() !== "";
}

export function valueParts(value: string): string[] {
  return value.split(";");
}

export function containingBoundaryValue(tags: OsmTags): string | undefined {
  return tags.boundary ??
    tags["disused:boundary"] ??
    tags["abandoned:boundary"] ??
    tags["historic:boundary"] ??
    tags["was:boundary"];
}

function hasText(value: string | undefined): value is string {
  return Boolean(value?.trim());
}
